import { Actions } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { StatusViewService } from "../../shared/services/status-view.service";
import { Injectable } from "@angular/core";

@Injectable()
export class MasterTransactionTableEffects {
    constructor(
        private actions$: Actions,
        private statusViewService: StatusViewService, 
        private store: Store
    ) { }
}
